import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('mediaFileAudioVolumeTargeting',  {
    bindings: {
      formName: '@',
      tooltipText: '@',
      readOnly: '<',
      audioVolumeTargeting: '<',
      audioVolumeMean: '<',
      audioMeasurementType: '@ ',
      volumeLufsMin: '<',
      volumeLufsMax: '<',
      isSupplyTag: '<',
      blockingUnknownAudioVolume: '<'
    },
    template: require("../templates/mediaFileAudioVolumeTargeting.html"),
    controllerAs: '$mediaFileAudioVolumeCtrl',
    controller: function() {
      var self = this;

      this.audioVolumeButtonOptions = componentHelper.allCustomOptions();
      this.audioTypeButtonOptions = componentHelper.audioTypeOptions();

      this.customTooltip = function(condition) {
        return componentHelper.valueIfCondition(condition, self.tooltipText);
      };

      this.setAudioVolumeMean = function(val) {
        self.audioVolumeMean = val;
      };

      this.setVolumeLufsMax = function(val) {
        self.volumeLufsMax = val;
      };

      this.setVolumeLufsMin = function(val) {
        self.volumeLufsMin = val;
      };
    }
});
